const appearanceMap = {
  default: "checkbox",
  size: "buttons",
  color: "swatch",
};

const getAppearanceFromCode = (code) => {
  return appearanceMap[code] ?? appearanceMap.default;
};

export default getAppearanceFromCode;
